import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class BackOfANapkinSlideoversBonComponent extends Component {
  @service organisation;
}
